/**
 * @fileoverview An object that provides constants for rendering blocks in Zelos
 * mode.
 */
"use strict";

import Blockly from "blockly";
/**
 * An object that provides constants for rendering blocks in gta mode.
 * @constructor
 * @package
 * @extends {Blockly.blockRendering.ConstantProvider}
 */

 Blockly.Flyout.prototype.SCROLLBAR_PADDING = -6;

Blockly.gta.ConstantProvider = function() {
  Blockly.gta.ConstantProvider.superClass_.constructor.call(this);

  this.GRID_UNIT = 4;
  // this.GRID_UNIT = 4;
  // debugger;
  /**
   * @override
   */
  this.CORNER_RADIUS = 0 * this.GRID_UNIT; //锯齿弧度，改
  // this.CORNER_RADIUS = 1 * this.GRID_UNIT;

  /**
   * @override
   * 凹槽宽度NOTCH_WIDTH
   */
  this.NOTCH_WIDTH = 0 * this.GRID_UNIT; //凹槽宽度，改
  // this.NOTCH_WIDTH = 9 * this.GRID_UNIT;

  /**
   * @override
   * 凹槽高度
   */
  this.NOTCH_HEIGHT = 0 * this.GRID_UNIT; //凹槽高度，改
  // this.NOTCH_HEIGHT = 2 * this.GRID_UNIT;

  /**
   * @override
   * 输入输出接口高度
   */
  this.TAB_HEIGHT = 15;
  /**
   * @override
   * 输入输出接口宽度
   */
  // this.TAB_WIDTH = 2; //改，
  this.TAB_WIDTH = 8;

  // 左右输入输出接口距离上部的距离
  //改
  // this.TAB_OFFSET_FROM_TOP = 0;
  // 默认
  this.TAB_OFFSET_FROM_TOP = 5;

  this.TAB_VERTICAL_OVERLAP = 25;
  /**
   * @override
   */
  // this.NOTCH_OFFSET_LEFT = 5 * this.GRID_UNIT;
  this.NOTCH_OFFSET_LEFT = this.GRID_UNIT;

  // this.NOTCH_OFFSET_LEFT = 3 * this.GRID_UNIT;
  this.EMPTY_BLOCK_SPACER_HEIGHT = 16;

  this.STATEMENT_BOTTOM_SPACER = 100;
  this.STATEMENT_INPUT_PADDING_LEFT = 40;

  // this.SPACER_DEFAULT_HEIGHT = 150;
  this.EMPTY_INLINE_INPUT_HEIGHT = 26;

  // this.EMPTY_INLINE_INPUT_PADDING =145;
  /**
   * @override
   * 输入积木之间以及字段的间距通过的改动
   * 改
   */
  // this.SMALL_PADDING = this.GRID_UNIT * 1;
  this.SMALL_PADDING = this.GRID_UNIT * 4;
  // 默认
  // this.NO_PADDING = 0;
  // this.SMALL_PADDING = 3;
  // this.MEDIUM_PADDING = 5;
  this.MEDIUM_LARGE_PADDING = 12;
  this.LARGE_PADDING = 8;


  // this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING;

  this.MIN_BLOCK_HEIGHT = 12 * this.GRID_UNIT;

  //不可编辑字段和输入的距离
  this.letter_padding = 0 * this.GRID_UNIT;
  // this.letter_padding = 1 * this.GRID_UNIT;

  // this.MIN_BLOCK_HEIGHT = 24;//默认
  this.MIN_BLOCK_WIDTH = 24 * this.GRID_UNIT; //默认

  // this.MIN_BLOCK_WIDTH = 12; //默认

  // this.EMPTY_INLINE_INPUT_PADDING = 14.5; //默认

  this.EXTERNAL_VALUE_INPUT_PADDING = 20; //输入间隙
  // this.EXTERNAL_VALUE_INPUT_PADDING = 20; //输入间隙
};
Blockly.utils.object.inherits(
  Blockly.gta.ConstantProvider,
  Blockly.blockRendering.ConstantProvider
);

/**
 * @override
 */

/**
 * NOTE:
 * Hexagonal:
 * adj. 六边的，六角形的
 *
 * Rounded:
 * adj. 圆形的；全面的；丰满的
 */

Blockly.gta.ConstantProvider.prototype.init = function() {
  Blockly.gta.ConstantProvider.superClass_.init.call(this);
  this.HEXAGONAL = this.makeHexagonal();
  this.ROUNDED = this.makeRounded();
  // this.PUZZLE_TAB = this.makePuzzleTab();
};

/**
 * @return {!Object} An object containing sizing and path information about
 *     a hexagonal shape for connections.
 * @package
 */
Blockly.gta.ConstantProvider.prototype.makeHexagonal = function() {
  // The 'up' and 'down' versions of the paths are the same, but the Y sign
  // flips.  Forward and back are the signs to use to move the cursor in the
  // direction that the path is being drawn.
  function makeMainPath(height, up, right) {
    // 改，宽高比
    var width = (height / 5) * 2;
    // 默认
    // var width = height / 2;
    var forward = up ? -1 : 1;
    var direction = right ? -1 : 1;

    return (
      Blockly.utils.svgPaths.lineTo(
        -1 * direction * width,
        (forward * height) / 2
      ) +
      Blockly.utils.svgPaths.lineTo(direction * width, (forward * height) / 2)
    );
  }

  return {
    width: 0,
    height: 0,
    isDynamic: true,
    pathDown: function(height) {
      return makeMainPath(height, false, false);
    },
    pathUp: function(height) {
      return makeMainPath(height, true, false);
    },
    pathRightDown: function(height) {
      return makeMainPath(height, false, true);
    },
    pathRightUp: function(height) {
      return makeMainPath(height, false, true);
    }
  };
};

/**
 * @return {!Object} An object containing sizing and path information about
 *     a rounded shape for connections.
 * @package
 */
Blockly.gta.ConstantProvider.prototype.makeRounded = function() {
  // The 'up' and 'down' versions of the paths are the same, but the Y sign
  // flips.  Forward and back are the signs to use to move the cursor in the
  // direction that the path is being drawn.
  function makeMainPath(height, up, right) {
    var edgeWidth = height / 2;
    return Blockly.utils.svgPaths.arc(
      "a",
      "0 0 " + (up || right ? 1 : 0),
      edgeWidth,
      Blockly.utils.svgPaths.point(0, (up ? -1 : 1) * edgeWidth * 2)
    );
  }

  return {
    width: 0,
    height: 0,
    isDynamic: true,
    pathDown: function(height) {
      return makeMainPath(height, false, false);
    },
    pathUp: function(height) {
      // 改 八边形的左边角
      var totalHeight = height;
      var height_1 = (totalHeight / 4).toFixed(2);
      var height_2 = totalHeight - 2 * height_1;
      var height_3 = -height_1;
      var height_4 = -height_2;
      var pathRight =
        "l" +
        height_3 +
        "," +
        height_3 +
        " " +
        "0" +
        "," +
        height_4 +
        " " +
        height_1 +
        "," +
        height_3 +
        " ";
      return pathRight;
      // 默认
      // return makeMainPath(height, true, false);
    },
    pathRightDown: function(height) {
      // 改成 八边形的右侧
      // debugger;
      var totalHeight = height;
      var height_1 = (totalHeight / 4).toFixed(2);
      var height_2 = totalHeight - 2 * height_1;
      var height_3 = -height_1;
      var pathRight =
        "l" +
        height_1 +
        "," +
        height_1 +
        " " +
        "0" +
        "," +
        height_2 +
        " " +
        height_3 +
        "," +
        height_1 +
        " ";
      return pathRight;
      // 默认
      // return makeMainPath(height, false, true);
    },
    pathRightUp: function(height) {
      return makeMainPath(height, false, true);
    }
  };
};

/**
 * @override
 */
Blockly.gta.ConstantProvider.prototype.shapeFor = function(connection) {
  var checks = connection.getCheck();
  switch (connection.type) {
    case Blockly.INPUT_VALUE:
    case Blockly.OUTPUT_VALUE:
      // Includes doesn't work in IE.
      if (checks && checks.indexOf("Boolean") != -1) {
        return this.HEXAGONAL;
      }
      if (checks && checks.indexOf("Number") != -1) {
        return this.ROUNDED;
      }
      if (checks && checks.indexOf("String") != -1) {
        return this.ROUNDED;
      }
      return this.PUZZLE_TAB;
    case Blockly.PREVIOUS_STATEMENT:
    case Blockly.NEXT_STATEMENT:
      return this.NOTCH;
    default:
      throw Error("Unknown type");
  }
};

/**
 * @override
 */
Blockly.gta.ConstantProvider.prototype.makeNotch = function() {
  var width = this.NOTCH_WIDTH;
  var height = this.NOTCH_HEIGHT;

  var innerWidth = width / 3;
  var curveWidth = innerWidth / 3;

  var halfHeight = height / 2;
  var quarterHeight = halfHeight / 2;

  function makeMainPath(dir) {
    return (
      Blockly.utils.svgPaths.curve("c", [
        Blockly.utils.svgPaths.point((dir * curveWidth) / 2, 0),
        Blockly.utils.svgPaths.point(
          (dir * curveWidth * 3) / 4,
          quarterHeight / 2
        ),
        Blockly.utils.svgPaths.point(dir * curveWidth, quarterHeight)
      ]) +
      Blockly.utils.svgPaths.line([
        Blockly.utils.svgPaths.point(dir * curveWidth, halfHeight)
      ]) +
      Blockly.utils.svgPaths.curve("c", [
        Blockly.utils.svgPaths.point((dir * curveWidth) / 4, quarterHeight / 2),
        Blockly.utils.svgPaths.point((dir * curveWidth) / 2, quarterHeight),
        Blockly.utils.svgPaths.point(dir * curveWidth, quarterHeight)
      ]) +
      Blockly.utils.svgPaths.lineOnAxis("h", dir * innerWidth) +
      Blockly.utils.svgPaths.curve("c", [
        Blockly.utils.svgPaths.point((dir * curveWidth) / 2, 0),
        Blockly.utils.svgPaths.point(
          (dir * curveWidth * 3) / 4,
          -(quarterHeight / 2)
        ),
        Blockly.utils.svgPaths.point(dir * curveWidth, -quarterHeight)
      ]) +
      Blockly.utils.svgPaths.line([
        Blockly.utils.svgPaths.point(dir * curveWidth, -halfHeight)
      ]) +
      Blockly.utils.svgPaths.curve("c", [
        Blockly.utils.svgPaths.point(
          (dir * curveWidth) / 4,
          -(quarterHeight / 2)
        ),
        Blockly.utils.svgPaths.point((dir * curveWidth) / 2, -quarterHeight),
        Blockly.utils.svgPaths.point(dir * curveWidth, -quarterHeight)
      ])
    );
  }

  // TODO: Find a relationship between width and path
  var pathLeft = makeMainPath(1);
  var pathRight = makeMainPath(-1);

  return {
    width: width,
    height: height,
    pathLeft: pathLeft,
    pathRight: pathRight
  };
};

/**
 * @return {!Object} An object containing sizing and path information about
 *     outside corners.
 * @package
 */
Blockly.gta.ConstantProvider.prototype.makeOutsideCorners = function() {
  var radius = this.CORNER_RADIUS;
  /**
   * SVG path for drawing the rounded top-left corner.
   * @const
   */
  var topLeft =
    Blockly.utils.svgPaths.moveBy(0, radius) +
    Blockly.utils.svgPaths.arc(
      "a",
      "0 0,1",
      radius,
      Blockly.utils.svgPaths.point(radius, -radius)
    );

  /**
   * SVG path for drawing the rounded top-right corner.
   * @const
   */
  var topRight = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,1",
    radius,
    Blockly.utils.svgPaths.point(radius, radius)
  );

  /**
   * SVG path for drawing the rounded bottom-left corner.
   * @const
   */
  var bottomLeft = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,1",
    radius,
    Blockly.utils.svgPaths.point(-radius, -radius)
  );

  /**
   * SVG path for drawing the rounded bottom-right corner.
   * @const
   */
  var bottomRight = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,1",
    radius,
    Blockly.utils.svgPaths.point(-radius, radius)
  );

  return {
    topLeft: topLeft,
    topRight: topRight,
    bottomRight: bottomRight,
    bottomLeft: bottomLeft
  };
};

/**
 * @override
 */
Blockly.gta.ConstantProvider.prototype.makeInsideCorners = function() {
  var radius = this.CORNER_RADIUS;

  var innerTopLeftCorner = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,0",
    radius,
    Blockly.utils.svgPaths.point(-radius, radius)
  );

  var innerTopRightCorner = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,1",
    radius,
    Blockly.utils.svgPaths.point(-radius, radius)
  );

  var innerBottomLeftCorner = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,0",
    radius,
    Blockly.utils.svgPaths.point(radius, radius)
  );

  var innerBottomRightCorner = Blockly.utils.svgPaths.arc(
    "a",
    "0 0,1",
    radius,
    Blockly.utils.svgPaths.point(radius, radius)
  );

  return {
    width: radius,
    height: radius,
    pathTop: innerTopLeftCorner,
    pathBottom: innerBottomLeftCorner,
    rightWidth: radius,
    rightHeight: radius,
    pathTopRight: innerTopRightCorner,
    pathBottomRight: innerBottomRightCorner
  };
};

/**
 * @return {!Object} An object containing sizing and path information about
 *     puzzle tabs.
 * 左连接和右连接部位
 * @package
//  */
Blockly.gta.ConstantProvider.prototype.makePuzzleTab = function() {
  var width = this.TAB_WIDTH;
  var height = this.TAB_HEIGHT;
  function makeMainPath(up) {
    var forward = up ? -1 : 1;
    var back = -forward;
    var overlap = 2.5;
    var halfHeight = height / 2 - 2.5;
    var totalHeight = height;
    var height_1 = (totalHeight / 4).toFixed(2);
    var height_2 = totalHeight - 2 * height_1;
    var height_3 = -height_1;
    var height_4 = -height_2;
    var pathRight =
      "l" +
      height_3 +
      "," +
      height_1 +
      " " +
      "0" +
      "," +
      height_2 +
      " " +
      height_1 +
      "," +
      height_1 +
      " ";
    return pathRight;
  }

  // 积木输出样式修改
  var pathUp = "c 0,0 -6,-17.5 -6,-17.5 c 0,0 6,-17.5 6,17.5 z";
  // var pathUp = makeMainPath(true); //左拼接

  var pathDown = " c 0,0  -6,7 -6,7 c 0,0 6,7 6,7"; //多边形
  var pathDown = makeMainPath(false); //右拼接

  return {
    width: width,
    height: height,
    pathDown: pathDown,
    pathUp: pathUp
  };
};

// Blockly.RenderedConnection.prototype.tighten_ = function(offsetX, offsetY) {
//   var dx = this.targetConnection.x_ - this.x_;
//   var dy = this.targetConnection.y_ - this.y_;
//   if (dx != 0 || dy != 0) {
//     var block = this.targetBlock();
//     var svgRoot = block.getSvgRoot();
//     if (!svgRoot) {
//       throw Error("block is not rendered.");
//     }
//     // Workspace coordinates.
//     var xy = Blockly.utils.getRelativeXY(svgRoot);
//     block
//       .getSvgRoot()
//       .setAttribute(
//         "transform",
//         "translate(" + (xy.x - dx) + "," + (xy.y - dy) + ")"
//       );
//     block.moveConnections_(-dx, -dy);
//   }
// };

// Blockly.BlockSvg.prototype.updateConnectionLocations_ = function() {
//   var blockTL = this.getRelativeToSurfaceXY();
//   // connections.
//   if (this.previousConnection) {
//     this.previousConnection.moveToOffset(blockTL);
//   }
//   if (this.outputConnection) {
//     this.outputConnection.moveToOffset(blockTL);
//   }
//   var offsetX = 0;
//   var offsetY = 0;
//   for (var i = 0; i < this.inputList.length; i++) {
//     //内部积木块连接的调用
//     var conn = this.inputList[i].connection;
//     if (conn) {
//       conn.moveToOffset(blockTL);
//       if (conn.isConnected()) {
//         if (this.type == "math_trig") {
//           // debugger
//           var offsetX = 0;
//           var offsetY = 0;
//           conn.tighten_(offsetX, offsetY);
//         } else {
//           conn.tighten_();
//         }
//       }
//     }
//   }

//   if (this.nextConnection) {
//     // 外部连接的调用
//     this.nextConnection.moveToOffset(blockTL);
//     if (this.nextConnection.isConnected()) {
//       this.nextConnection.tighten_();
//     }
//   }
// };
//toolbox工具条积木svg的宽度设置
Blockly.Flyout.prototype.positionAt_ = function(width, height, x, y) {
  // debugger;
  sessionStorage.flyoutWidth = width;
  sessionStorage.flyoutHeight = height;
  width = width > 120 ? width : "120";
  this.svgGroup_.setAttribute("width", width);
  this.svgGroup_.setAttribute("height", height + 30);
  if (this.svgGroup_.tagName == "svg") {
    var transform = "translate(" + x + "px," + y + "px)";
    Blockly.utils.dom.setCssTransform(this.svgGroup_, transform);
  } else {
    // IE and Edge don't support CSS transforms on SVG elements so
    // it's important to set the transform on the SVG element itself
    var transform = "translate(" + x + "," + y + ")";
    this.svgGroup_.setAttribute("transform", transform);
  }

  // Update the scrollbar (if one exists).
  if (this.scrollbar_) {
    // Set the scrollbars origin to be the top left of the flyout.
    this.scrollbar_.setOrigin(x, y);
    this.scrollbar_.resize();
    // Set the position again so that if the metrics were the same (and the
    // resize failed) our position is still updated.
    this.scrollbar_.setPosition_(
      this.scrollbar_.position_.x,
      this.scrollbar_.position_.y
    );
  }
};


